// AlloLabs UK — laboratory reference standards catalogue.
// Research Use Only (RUO). No pricing by design (strictly B2B wholesale).

export const BOX_GALLERY = [
  "https://static.prod-images.emergentagent.com/jobs/4ea71cde-a4d0-4acf-8f52-1fbf881bb771/images/54c5ce292b630f5b8dadd299a5140fc2a20638eb82a9d0cc03206daceb86e477.jpeg",
  "https://static.prod-images.emergentagent.com/jobs/4ea71cde-a4d0-4acf-8f52-1fbf881bb771/images/7a707ef14f9ab95d8d92a55116e1adc6ee13137c0c19b9f94c9ab4197a58aee0.jpeg",
];

const BOX_IMAGE =
  "https://customer-assets-cm19k8pv.emergentagent.net/job_lab-chem-uk/artifacts/oo4pfeoc_allobox.webp";

export const SERIES = [
  {
    id: "metabolic",
    index: "01",
    name: "Advanced Metabolic Research Series",
    blurb:
      "High-molecular-weight sequences employed in metabolic pathway assays and receptor-binding reference work.",
    products: [
      {
        id: "c225-h348",
        name: "GLP-2 (TR)",
        ref: "C225-H348",
        formula: "C225H348N48O68",
        image: BOX_IMAGE,
        gallery: ["/coa-tirzep.png"],
        coaPdf: "/coa-tirzep.pdf",
        mg: ["10mg", "20mg", "30mg", "40mg"],
        use: "GLP-2 (TR) is a synthetic peptide analogue acting as a dual GIP and GLP-1 receptor agonist, widely used in metabolic research. AlloLabs supplies this material as a high-purity lyophilised reference standard intended exclusively for in-vitro laboratory analysis, assay calibration and mass-spectrometry reference work.\n\nFor laboratory research and scientific use only. Not for human consumption, therapeutic or diagnostic purposes.",
      },
      {
        id: "retatrutide",
        name: "GLP-3 (RT)",
        ref: "C221-H342",
        formula: "C221H342N46O68",
        image: BOX_IMAGE,
        gallery: ["/coa-reta.png"],
        coaPdf: "/coa-reta.pdf",
        mg: ["10mg", "20mg", "30mg"],
        use: "GLP-3 (RT) is a synthetic peptide acting as a triple agonist of the GIP, GLP-1 and glucagon receptors, employed in advanced metabolic research. AlloLabs supplies it as a high-purity lyophilised reference standard intended exclusively for in-vitro laboratory analysis and mass-spectrometry reference work.\n\nFor laboratory research and scientific use only. Not for human consumption, therapeutic or diagnostic purposes.",
      },
    ],
  },
  {
    id: "skincare",
    index: "02",
    name: "Skincare & Anti-Aging Blends",
    blurb:
      "High-purity peptide standards employed in dermatological synthesis, skin-matrix and anti-aging reference research.",
    products: [
      {
        id: "ghk-cu",
        name: "GHK-Cu",
        ref: "GHK-Cu",
        formula: "C14H22N6O4·Cu",
        image: "https://static.prod-images.emergentagent.com/jobs/4ea71cde-a4d0-4acf-8f52-1fbf881bb771/images/ab11bb3842254130226005fe380e05dbdb06ea254dd97aa64f64285824c85bf3.jpeg",
        gallery: ["/coa-ghkcu.png"],
        coaPdf: "/coa-ghkcu.pdf",
        mg: ["50mg", "100mg"],
        use: "GHK-Cu (Copper Peptide) – A high-purity reference standard for regenerative research\n\nGHK-Cu is a high-purity copper peptide supplied as a lyophilised reference standard. It is a key tool in research on collagen synthesis, extracellular-matrix (ECM) remodelling and regenerative processes in in-vitro skin models.\n\nIts mechanism of action is based on the ability to chelate copper ions, which activates matrix metalloproteinases (MMPs) and signalling pathways linked to the expression of collagen, elastin and glycosaminoglycan genes. It additionally stimulates fibroblast activity, supporting research on tissue remodelling and the reduction of oxidative stress.\n\nKey research applications:\n• Modelling extracellular-matrix (ECM) remodelling in dermatological research.\n• Analysis of anti-inflammatory and antioxidant pathways in the context of photoaging.\n• Research on skin-structure regeneration, wound healing and hair-follicle growth (in-vitro models).",
      },
      {
        id: "ac-kpv",
        name: "Ac-KPV-NH2 (N-Acetyl KPV Amidate)(Ultra Stable Grade)",
        ukExclusive: true,
        ref: "Ac-KPV",
        formula: "C18H33N5O4",
        image: BOX_IMAGE,
        gallery: ["/coa-ackpv.png"],
        coaPdf: "/coa-ackpv.pdf",
        mg: ["10mg"],
        use: "An acetylated, C-terminally amidated tripeptide (Lys-Pro-Val) with enhanced stability and bioavailability compared to standard KPV. Thanks to the added acetyl and amide groups the molecule resists degradation, making it significantly more effective in research on anti-inflammatory pathways and dermatological signalling.\n\n⚠️ UK EXCLUSIVE:\nAlloLabs is currently the exclusive distributor of this enhanced, high-quality version of KPV in the UK. You will not find it in any other British store. It is our most advanced and unique research formula.\n\nFor laboratory research and scientific use only. Not for human consumption, therapeutic or diagnostic purposes.",
      },
    ],
  },
  {
    id: "tissue",
    index: "03",
    name: "Tissue & Cellular Integrity Series",
    blurb:
      "Mitochondria-targeted and neuroendocrine sequences used in cellular integrity and tissue-model reference research.",
    products: [
      {
        id: "ss31",
        name: "SS-31 (Elamipretide)",
        ref: "SS-31",
        formula: "C32H49N9O5",
        image: BOX_IMAGE,
        gallery: ["/coa-ss31.png"],
        coaPdf: "/coa-ss31.pdf",
        mg: ["5mg", "10mg"],
        use: "SS-31 (Elamipretide) is a highly purified, synthetic mitochondria-targeted tetrapeptide supplied as a lyophilised reference standard. Used in advanced research on cardiolipin binding, mitochondrial protection and cellular bioenergetics, particularly in oxidative-stress models.\n\nAlloLabs provides this material as a high-purity analytical standard intended exclusively for in-vitro laboratory research and reference work.\n\nFor laboratory research and scientific use only. Not for human consumption, therapeutic or diagnostic purposes.",
      },
      {
        id: "dsip",
        name: "DSIP",
        ref: "DSIP",
        formula: "C35H48N10O15",
        image: BOX_IMAGE,
        gallery: ["/coa-dsip.png"],
        coaPdf: "/coa-dsip.pdf",
        mg: ["2mg", "5mg", "12mg"],
        use: "DSIP is a nonapeptide supplied as a high-purity lyophilised reference standard. In tissue and cellular integrity research it is used to analyse cytoprotective mechanisms, evaluate effects on hormonal balance and study antioxidant pathways that support homeostasis and the protection of cell-membrane structure in in-vitro models.\n\nIts unique research properties lie in its ability to modulate the neuroendocrine axis, making it a valuable tool in analyses of oxidative stress, protection of cells against damage and the regulation of repair processes in tissues.\n\nKey research applications:\n• Assessment of cytoprotective mechanisms and cell-membrane protection under oxidative stress.\n• Study of hormonal balance and homeostasis in in-vitro models.\n• Analysis of anti-inflammatory pathways and tissue-repair processes.",
      },
    ],
  },
  {
    id: "modulation",
    index: "04",
    name: "Cellular Modulation Series",
    blurb:
      "Acetylated tetrapeptide standards supplied as high-purity analytical references for cellular-modulation research.",
    products: [
      {
        id: "na-epitalon",
        name: "NA-Epitalon Amidate (Ultra Stable Grade)",
        ukExclusive: true,
        ref: "NA-Epitalon",
        formula: "C16H25N5O9",
        image: BOX_IMAGE,
        gallery: ["/coa-epitalon.png"],
        coaPdf: "/coa-epitalon.pdf",
        mg: ["10mg", "20mg"],
        use: "An N-acetylated, C-amidated tetrapeptide (Ala-Glu-Asp-Gly) with enhanced stability and bioavailability compared to standard Epitalon. Thanks to the Amidate modifications the molecule is far more resistant to degradation, making it an ideal reference standard for advanced research on telomerase activation, cellular modulation and cellular longevity.\n\n⚠️ UK EXCLUSIVE:\nAlloLabs is currently the exclusive distributor of this enhanced, high-quality version of Epitalon in the UK. You will not find it in any other British store. It is our most advanced and unique research formula.\n\nFor laboratory research and scientific use only (Research Use Only). Not for human consumption, therapeutic or diagnostic purposes.",
      },
    ],
  },
  {
    id: "neuro",
    index: "05",
    name: "Neuro-Protective & Nootropics Series",
    blurb:
      "Neuro-active reference sequences supplied for neuroprotection and cognitive-pathway analytical research.",
    products: [
      {
        id: "na-semax",
        name: "NA-Semax Amidate (Ultra Stable Grade)",
        ref: "NA-Semax",
        formula: "C39H54N10O10S",
        image: BOX_IMAGE,
        gallery: ["/coa-semax.png"],
        coaPdf: "/coa-semax.pdf",
        mg: ["5mg", "10mg"],
        use: "An N-acetylated, amidated heptapeptide analogue with enhanced stability and bioavailability compared to standard Semax. Thanks to the Amidate modifications the molecule is far more resistant to degradation, making it an ideal reference standard for advanced research on neuroprotective mechanisms, BDNF expression and cognitive pathways.\n\nFor laboratory research and scientific use only. Not for human consumption, therapeutic or diagnostic purposes.",
      },
      {
        id: "na-selank",
        name: "NA-Selank Amidate (Ultra Stable Grade)",
        ref: "NA-Selank",
        formula: "C35H60N12O9",
        image: BOX_IMAGE,
        gallery: ["/coa-selank.png"],
        coaPdf: "/coa-selank.pdf",
        mg: ["5mg", "10mg"],
        use: "An N-acetylated, amidated heptapeptide analogue with enhanced stability and bioavailability compared to standard Selank. Thanks to the Amidate modifications the molecule is far more resistant to degradation, making it an ideal reference standard for advanced research on anxiolytic mechanisms, GABA-ergic system modulation and neuro-immune signalling.\n\nFor laboratory research and scientific use only. Not for human consumption, therapeutic or diagnostic purposes.",
      },
      {
        id: "dsip-n",
        name: "DSIP",
        ref: "DSIP",
        formula: "C35H48N10O15",
        image: BOX_IMAGE,
        gallery: ["/coa-dsip.png"],
        coaPdf: "/coa-dsip.pdf",
        mg: ["2mg", "5mg", "12mg"],
        use: "DSIP is a nonapeptide supplied as a high-purity lyophilised reference standard. Used in advanced in-vitro research on the regulation of deep (delta) sleep phases, circadian rhythm and neuroprotective mechanisms. Valued in nootropic research for its potential influence on neurotransmission pathways, nerve-cell regeneration and nervous-system homeostasis.\n\nFor laboratory research and scientific use only. Not for human consumption, therapeutic or diagnostic purposes.",
      },
    ],
  },
];

export const RESEARCH_BOXES = [
  {
    id: "metabolic-box",
    name: "Metabolic Evaluation Box",
    desc: "Mixed weights of dual- and tri-agonist metabolic sequences, curated for comprehensive pathway benchmarking.",
    tags: ["GLP-2 (TR)", "GLP-3 (RT)"],
  },
  {
    id: "derma-box",
    name: "Dermatological Synthesis Box",
    desc: "Combined GHK-Cu and Ac-KPV-NH2 peptide standards for dermatological synthesis and anti-aging research.",
    tags: ["GHK-Cu", "Ac-KPV-NH2"],
  },
  {
    id: "cognitive-box",
    name: "Cognitive & Longevity Standard Box",
    desc: "Curated neuro-protective, nootropic and sleep-pathway reference kits for cognitive and longevity research.",
    tags: ["NA-Semax", "NA-Selank", "DSIP"],
  },
];
